import { useEffect, useState } from "react";
import { KBD } from "../utils/Keybindings";
import { ROUTES } from "../utils/Routes";
import { listen } from "../hooks/Listener";
import { createModal } from "../hooks/createModal";
import Menu from "../ui/Menu";
import Card from "../ui/Card";
import Label from "../ui/Label";
import ReportsCustomInventory from "../components/ReportsCustomInventory";
import Divider from "../ui/Divider";
import Space from "../ui/Space";
import Nav from "../ui/Nav";
import ProcessingList from "../components/ProcessingList";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import ProcessingDetails from "../components/ProcessingDetails";
import { buildFileFromChunks } from "../utils/Utils";
import PurchaseOrderUpdate from "../popups/PurchaseOrderUpdate";
import { ENUMS } from "../utils/Enums";
import Spin from "../ui/Spin";
import { drawPicker } from "../popovers/Picker";
import OrderTotalsBySection from "../components/order_processing/OrderTotalsBySection";

export default function OrderProcessingController(props) {

    const { controller = "", signal = {}, setController = () => { } } = props;

    const route = ROUTES.PROCESSING.PROCESSING;
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState({});
    const [selectedItem, setSelectedItem] = useState({});
    const [items, setItems] = useState([]);
    const [align, setAlign] = useState("auto");
    const [view, setView] = useState(true);
    const [edit, setEdit] = useState(false);
    const [filters, setFilters] = useState({ limit: 45, sort: "status", send_via: "", minimum: "", pending_separators: "", supplier_types: "", only_pending: false })
    const row_key = "purchase_order_id";

    const processing_nav = [
        { key: KBD.ESCAPE, action: () => { setController("home") } },
        { text: "Edt" },
        { text: "Flt" },
        { text: "Indx" },
        { text: "Log" },
        { key: KBD.O, text: "Ok", action: () => { toggleOk(selected) } },
        { key: KBD.P, text: "Process", action: () => { prepareOrderDocument(selected); } },
        { key: KBD.R, text: "Rettl", action: () => { reTotal(selected) } },
        { text: "Search" },
        { text: "Telephone" },
        { key: KBD.U, text: "Update", action: () => { drawUpdate() } },
        { text: "View" },
        { key: KBD.X, text: "Xtra", action: () => drawExtra() },
    ]

    useEffect(() => {
        window.bm_state.value = route;
        const cleanup = listen(controller, route, processing_nav);
        return cleanup;
    }, [processing_nav, selected])




    const updateRow = (_row) => {
        let _d = [...data];
        let _f = _d.findIndex(item => item?.[row_key] === _row?.[row_key]);
        if (_f > -1) {
            _d[_f] = _row;
            setSelected(_d[_f]);
            setData(_d);
        }
    }


    const prepareOrderDocument = (_selected = selected) => {

        const options = {
            ship_via: "",
            stock_status: false,
            order_number: "",
            backorders: "",
            cancel_by_days: 0,
            promo_code: "",
            notes: "",
            supplier_notes: "",
            print_copy: false,
            cascade_options: 0,
            mark_as_sent: false,
            purchase_order_id: _selected?.[row_key]
        }

        setLoading(true);
        pubCall("purchase_order.prepareOrderDocument", options, (_s, _r) => {
            if (_s) {
                buildFileFromChunks(_r, pubCall, setLoading, () => {
                    showMessage("File created successfully.")
                })
            } else {
                showError(_r);
            }
        })
    }

    const toggleOk = (_selected = selected) => {

        setLoading(true);
        pubCall("purchase_order.toggleOk", { purchase_order_id: selected?.purchase_order_id, is_ok: !_selected?.ready }, (_s, _r) => {
            if (_s) {
                updateRow(_r);
            } else {
                showError(_r);
            }
            setLoading(false);
        })

    }

    const reTotal = (_selected = selected) => {
        setLoading(true)
        pubCall("purchase_order.retotal", { purchase_order_id: _selected?.[row_key] }, (_s, _r) => {
            if (_s) {
                console.log(JSON.stringify(_r, null, 2))
            } else {
                showError(_r);
            }
        })
    }

    const runUpdate = (_filters) => {
        setLoading(true)
        pubCall("purchase_order.update", _filters, (_s, _r) => {
            if (_s) {
                showMessage("Update complete.")
            } else {
                showError(_r);
            }
            setLoading(false)
        })
    }


    const drawUpdate = () => {
        window.bm_state.value = ROUTES.PROCESSING.UPDATE;
        createModal({
            component: <PurchaseOrderUpdate controller={controller} filters={filters} options={ENUMS.ORDER_UPDATE_OPTIONS} route={ROUTES.PROCESSING.UPDATE} />, closable: true, title: <>Update</>, callback: (_filter) => {
                if (_filter) {
                    runUpdate(_filter);
                }
                window.bm_state.value = route;
            }
        })
    }


    const drawOrderTotalsBySection = () => {
        window.bm_state.value = ROUTES.PROCESSING.ORDER_TOTALS_BY_SECTION;
        createModal({
            component: <OrderTotalsBySection item={selected} controller={controller} route={ROUTES.PROCESSING.ORDER_TOTALS_BY_SECTION} />, closable: true, title: <>Order totals by section</>, callback: (_filter) => {
                if (_filter) {
                    runUpdate(_filter);
                }
                window.bm_state.value = route;
            }
        })
    }


    const drawExtra = () => {

        const extraOptions = [
            { value: "R", label: "Reprint / View this PO", key: KBD.R },
            { value: "V", label: "Void this PO (revert to Pending)", key: KBD.V },
            { value: "A", label: "Change the PO#", key: KBD.A },
            { value: "B", label: "Change the cancel date (use <E>dit)", key: KBD.B },
            { value: "C", label: "Change discounts on the PO", key: KBD.C },
            { value: "D", label: "Change publication dates", key: KBD.D },
            { value: "E", label: "Change the Supplier", key: KBD.E },
            { value: "F", label: "Change the Order status for items on the PO", key: KBD.F },
            { value: "T", label: "View order totals by section", key: KBD.T },
        ];

        drawPicker({
            controller: controller,
            show_keys: true,
            allow_keys: true,
            value: "", title: "Notify Via", closeable: true, height: 300, ref: null, route: route, close: () => { }, callback: (e) => {
                if (e) {
                    switch (e) {
                        case "T":
                            setTimeout(() => {
                                drawOrderTotalsBySection()
                            }, 10)
                            
                            break;
                        default:
                            break
                    }
                }
            }, offset: [0, 10],
            options: extraOptions
        })
    }


    return (
        <div className="controller">
            <Spin loading={loading}>
                <div style={{ height: "calc(100vh - 74px)", minHeight: "600px", gap: "15px" }}>
                    <ProcessingDetails controller={controller} setSelectedItem={setSelectedItem} setSelected={setSelected} items={items} setItems={setItems} selected={selected} />
                    <div className="shim" />
                    <ProcessingList
                        controller={controller}
                        loading={loading}
                        setLoading={setLoading}
                        route={route}
                        data={data}
                        setData={setData}
                        selected={selected}
                        setSelected={setSelected}
                        signal={signal}
                        align={align}
                        setAlign={setAlign}
                        view={view}
                        filters={filters}
                        setFilters={setFilters}
                        row_key={row_key}
                    />
                    <div className="shim" />
                    <Divider />
                    <div style={{ 'height': "30px" }}>
                        <Space style={{ "padding": "0px 15px" }}>
                            <Nav nav={processing_nav} />
                        </Space>
                    </div>
                </div>
            </Spin>
        </div>
    )
}


